export const ADD_USER_ONE = "add/user/one";
export const ADD_USER_TWO = "add/user/two";
export const ADD_BACKGROUND = "add/background";
export const ADD_USER_ONE_AVATAR = "add/user/one/avatar";
export const ADD_USER_TWO_AVATAR = "add/user/two/avatar";
export const ADD_USER_ONE_POINTS = "add/user/one/points";
export const ADD_USER_TWO_POINTS = "add/user/two/points";
export const CURRENT_USER = "current/user";
export const RESET_USER_SCORE = "score/reset";
export const GET_FROM_DATABASE = "get/points/database";
export const GAME_OVER = "game/over";
